export default __webpack_public_path__ + "static/media/UserIcon.1630e4bd.svg";